import * as React from "react";
import Button from "@mui/material/Button";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from '@mui/material/Checkbox';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import moment from "moment";
import { Task } from "../../node_modules/@mui/icons-material/index";
import {logger,muiLoaderOptions} from '../utils';
import { Stack,CircularProgress } from '@mui/material';
import Fade from '@mui/material/Fade';
import FormHelperText from '@mui/material/FormHelperText';
export default function DayDialog({ handleDialogCallback, week }) {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [User, setUser] = React.useState('');
    const [TaskID, setTaskID] = React.useState('');
    const [taskIdValid, setTaskIdValid] = React.useState(false);
    const [role, setRole] = React.useState('');
    const [Hours, setHours] = React.useState();
    const [timeType, setTimeType] = React.useState("NT")
    const [lab, setLab] = React.useState(0)
    const [day, setDay] = React.useState(week);
    const [propList, setPropListChoices] = React.useState([]);
    const [ignored, forceupdate] = React.useReducer(x => x + 1, 0);
    const [RoleChoices, setRolesChoices] = React.useState([])
    const [UserChoices, setUserChoices] = React.useState([])
    const [TaskChoices, setTaskChoices] = React.useState([])
    const [taskItemChoices, setTaskItemChoices] = React.useState([]);
    const [expand, setExpand] = React.useState(false);
    const [expandTask, setExpandTask] = React.useState(false);
    const [LockedAlert, setAlert] = React.useState(false);
    const [AlertText, setAlertText] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(true);

    const separatorList = {
        period: {
            name: "period",
            regex: /^\d+(\.\d{0,2})?$/
        }
    };

    function handleChange(event) {
        setTaskID(event.target.value);
        logger('TimeEntry', event.target.value)
        logger('TE TaskChoices', TaskChoices)
        let temp = TaskChoices.filter(obj => obj.value === event.target.value);
        logger('Task Selected',temp);
        if (temp[0].label === "PTO") {
			setAlertText("Have you already submitted the ADP request for PTO? ");
			setAlert(true);
		}

        fetch(`/api/task_variable/${temp[0].GroupID}/${temp[0].value}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => setPropList(json))
            .then(logger(propList))
    };

    function ChangePropList(e, i) {
        const clonedData = propList
        
        clonedData[i].TaskItemID = e.target.value

        setPropListChoices(clonedData)
        forceupdate();
    };

    const setUsers = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.FirstName + " " + choice.LastName, value: choice.ID, default: choice.IV, assigned: choice.AssignedTo, DefaultRoleID: choice.DefaultRoleID, DefaultLab: choice.DefaultLab }))
            setUser(choices[0].default)
        setRole(choices[0].DefaultRoleID);
        setLab(choices[0].DefaultLab)

        setUserChoices(choices)
        setRefresh(true)
    }

    const setPropList = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, TaskVariableID: choice.TaskVariableID, TaskItemID: choice.TaskItemID ? choice.TaskItemID : '', IsDropdown: choice.IsDropdown }))
        setPropListChoices(choices)
    }

    const setTaskItem = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID, TaskVariableID: choice.TaskVariableID }))
        setTaskItemChoices(choices)
    }

    const setRoles = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Lab + "-" + choice.Position, value: choice.ID, lab: choice.LabID }))
        setRolesChoices(choices)
    }

    const setTask = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID, GroupID: choice.GroupID}))
        setTaskChoices(choices)
    }

    const CheckBilled = async (labOf, TaskOf) => {
        
        const response = await fetch(`/api/Time_Entry/CheckBilled/${labOf}/${TaskOf}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                return json;
            });
        return response;
    }
    const Check = async (list) => {
        let output = false;
                list.forEach((e, index) => {
                    if (moment(day).isBetween(e.StartDate, e.EndDate)) {
                        setAlertText("This time period has been locked. Check Entries or contact your Lead for assistance")
                        setAlert(true)
                        output = true;
                    }
                })

                if (!output) {
                    logger('will be saved')
                    onTrigger()
                }

    }

    const getHierarchy = async () => {
        await fetch('/api/User/dropdown/hierarchy', {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => setUsers(json));
    }

    React.useEffect(() => {
        if (refresh) {

            logger(`api/role/dropdown/${User}`);
            fetch(`api/role/dropdown/${User}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
					setRoles(json);
					setIsLoading(false);
					});
            if (!expandTask) {
                fetch(`api/Task/dropdown/${lab}`, {
                    method: 'Get',
                })
                    .then(res => res.json())
                    .then(json => setTask(json));
            } else {
                fetch('api/Task/dropdown', {
                    method: 'Get',
                })
                    .then(res => res.json())
                    .then(json => setTask(json));
            }

            fetch('api/task_prop_item', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => { setTaskItem(json) });

            setRefresh(false);
        }
    })

    const onTrigger = React.useCallback(() => {
        
        
        const msg = {
            UserID: User,
            TaskID: TaskID,
            RoleID: role,
            Hours: Hours,
            TimeType: timeType,
            DayOf: day,
            propList: propList
        };

        handleDialogCallback(msg)
        handleClose();
    })

    const handleClickOpen = () => {
        getHierarchy()
            //.then(setRefresh(true))
        setOpen(true);
        setDay(week);
    };

    const handleAlertClose = () => {
        setAlert(false);
    };

    const handleClose = () => {
        setUser(UserChoices[0].default)
        setTaskID('');
        setHours(0);
        setDay(week);
        setTimeType("NT");
        setPropListChoices([]);
        setExpand(false);
        setExpandTask(false);
        setOpen(false);
    };

    return (
        <div>

            <Button variant="contained" onClick={handleClickOpen}>
                Enter
            </Button>
            <Dialog open={open} onClose={handleClose}>
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                            Add Time
                        </Typography>
                        <Button autoFocus color="inherit" onClick={() => {
							if(TaskID ==='')setTaskIdValid(true); else setTaskIdValid(false);
							var mins = Hours.toString().substring(Hours.toString().indexOf(".")+1);
							if (mins !== null && mins !== "" && Hours.indexOf(".")!==-1 && (mins.length === 1 ? parseInt(mins + "0") : parseInt(mins)) % 25 !== 0) {
								setAlertText(`Please add time by the quarter hour(" .25 , .5 , .75 ")`);								
								setAlert(true);
								return;
							}
                            if (Hours != 0 && TaskID) {
                            CheckBilled(lab, TaskID, day)
                                    .then(response => Check(response))
                            } else {
                                setAlertText(`you need to add ${Hours == 0 ? 'Time' : ''} ${(Hours == 0 && TaskID == 0) ? 'and' : ''} ${TaskID ? '' : 'Task'}`)
                                setAlert(true)
                            }
                        }}>
                            save
                        </Button>
                    </Toolbar>
                </AppBar>
                 {(isLoading) &&

                                        <FormControl sx={{ m: 1, height: 200, width: 300 }}>
                                          
                                                <Fade
                                                    in={(isLoading)}
                                                    style={{
                                                        transitionDelay: !isLoading ? '800ms' : '0ms',
                                                    }}
                                                    unmountOnExit
                                                >
                                                    <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row" justifyContent="center">
                                                        <CircularProgress color="secondary" />
                                                        <CircularProgress color="success" />
                                                        <CircularProgress color="inherit" />
                                                    </Stack>
                                                </Fade>
                                           
                                        </FormControl>
                                    }
                                 {(!isLoading) &&
                <DialogContent style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ display: "column", flexDirection: "row" }}>
                        <FormControl style={{ minWidth: 240, display: "flex", flexDirection: "row" }}>
                            <InputLabel >
                                User
                            </InputLabel>
                            <Select
                                size="large"
                                sx={{ m: 1 }}
                                style={{ textAlign: 'center', minWidth: 200}}
                                labelId="UserSelection"
                                id="UserSelection"
                                value={User}
                                label="User"
                                onChange={e => {
                                    setUser(e.target.value);
                                  /*  setRole(e.target.DefaultRoleID);
                                    setLab(e.target.DefaultLab);*/
                                    UserChoices.forEach(choice => {
                                        if (e.target.value === choice.value) {
                                            setRole(choice.DefaultRoleID);
                                            setLab(choice.DefaultLab)
                                        }
                                    });
                                    setRefresh(true);
                                }}
                            >
                                {UserChoices.map((Choice, index) => {
                                    if ((Choice.assigned == Choice.default || Choice.default == Choice.value) || expand) {
                                        return (
                                            <MenuItem key={index} value={Choice.value}>{Choice.label}</MenuItem>
                                        );
                                    }
                                })}
                            </Select>
                            <Tooltip title="Expand User List" placement="top-end">
                                <FormControlLabel control={<Checkbox checked={expand} onClick={() => { setExpand(!expand); }} />} />
                            </Tooltip>
                        </FormControl>
                        <FormControl style={{ minWidth: 240 }}>
                            <InputLabel id="RoleSelection">
                                Roles
                            </InputLabel>
                            <Select
                                size="large"
                                sx={{ m: 1 }}
                                style={{ textAlign: 'center' }}
                                labelId="RoleSelection"
                                id="RoleSelectonDropdown"
                                value={role}
                                label="Role"
                                onChange={e => {
                                    setRole(e.target.value)
                                    let temp = RoleChoices.filter(Choice => Choice.value == e.target.value)
                                    logger(RoleChoices.filter(Choice => Choice.value == e.target.value))
                                    setLab(temp[0].lab)
                                    logger(`Role: ${role} AND Lab: ${lab} AND Target: ${e.target.value}`)
                                    setRefresh(true);
                                }}
                            >
                                {RoleChoices.map((Choice, index) => {
                                    return (
                                        <MenuItem key={index} value={Choice.value}>{Choice.label}</MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                        <div>
                        <FormControl required style={{ minWidth: 240 }}>
                        <InputLabel >
                            Day
                            </InputLabel>
                        <Select
                            size="large"
                            sx={{ m: 1 }}
                            style={{ textAlign: 'center' }}
                            value={day}
                            label="Day"
                            onChange={e => setDay(e.target.value)}
                        >
                                <MenuItem value={week}>Mon {moment(week).format('MM-DD-YYYY')}</MenuItem>
                                <MenuItem value={moment(week).add(1, 'days').format('YYYY-MM-DD')}>Tue {moment(week).add(1, 'days').format('MM-DD-YYYY')}</MenuItem>
                                <MenuItem value={moment(week).add(2, 'days').format('YYYY-MM-DD')}>Wed {moment(week).add(2, 'days').format('MM-DD-YYYY')}</MenuItem>
                                <MenuItem value={moment(week).add(3, 'days').format('YYYY-MM-DD')}>Thu {moment(week).add(3, 'days').format('MM-DD-YYYY')}</MenuItem>
                                <MenuItem value={moment(week).add(4, 'days').format('YYYY-MM-DD')}>Fri {moment(week).add(4, 'days').format('MM-DD-YYYY')}</MenuItem>
                                <MenuItem value={moment(week).add(5, 'days').format('YYYY-MM-DD')}>Sat {moment(week).add(5, 'days').format('MM-DD-YYYY')}</MenuItem>
                                <MenuItem value={moment(week).add(6, 'days').format('YYYY-MM-DD')}>Sun {moment(week).add(6, 'days').format('MM-DD-YYYY')}</MenuItem>
                            </Select>
                            </FormControl>
                            </div>
                        <FormControl style={{ minWidth: 240, display: "flex", flexDirection: "row" }}>
                            <InputLabel >
                                Task
                            </InputLabel>
                            <Select
                                size="large"
                                sx={{ m: 1 }}
                                style={{ textAlign: 'center', minWidth: 200 }}
                                
                                value={TaskID}
                                label="Task"
                                onChange={handleChange}
                                error={taskIdValid}
                            >
                                {TaskChoices.map((Choice, index) => {
                                    return (
                                        <MenuItem key={index} value={Choice.value} name={Choice.label}>{Choice.label}</MenuItem>
                                    );
                                })}
                            </Select>
                            <Tooltip title="See tasks outside your Team" placement="top-end">
                            <FormControlLabel control={<Checkbox checked={expandTask} onClick={() => {
                                setExpandTask(!expandTask)
                                setRefresh(true)
                                }} />} />
                            </Tooltip>
                        </FormControl>
                        <div style={{ verticalAlign: "bottom" }}>
                            <FormControl style={{ minWidth: 100 }}>
                                <TextField
                                    label="Hours"
                                    sx={{ m: 1 }}
                                    id="outlined-number"
                                    value={Hours}
                                    type="number"

                                    InputProps={{
                                        inputProps: {
                                            max: 24,
                                            min: 0,
                                            style: {
                                                textAlign: "center",
                                                minWidth: 120
                                            }
                                        }
                                    }}
                                    onChange={e => {
                                        if (separatorList["period"].regex.test(e.target.value)) {
                                            setHours(e.target.value);
                                        }
                                    }}
                                />
                            </FormControl>
                            <FormControl style={{ minWidth: 120 }}>
                                <InputLabel >
                                    NT/OT
                                </InputLabel>
                                <Select
                                    size="large"
                                    sx={{ m: 1 }}
                                    style={{ textAlign: 'center' }}
                                    
                                    value={timeType}
                                    label="NT/OT"
                                    onChange={e => setTimeType(e.target.value)}
                                >
                                    <MenuItem value={'NT'}>NT</MenuItem>
                                    <MenuItem value={'OT'}>OT</MenuItem>
                                    <MenuItem value={'WND'}>WND</MenuItem>
                                    <MenuItem value={'HOL'}>HOL</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div>
                        {propList.map((p, index) => {                           
                            if (p.IsDropdown) {
                                logger('proplist', p)
                                return (
                                    <div key={index}>
                                        <FormControl style={{ minWidth: 240 }}>
                                            <InputLabel id={p.label + index}>
                                                {p.label}
                                            </InputLabel>
                                            <Select
                                                size="large"
                                                sx={{ m: 1 }}
                                                style={{ textAlign: 'center' }}
                                                labelId={p.label}
                                                id={index}
                                                value={p.TaskItemID}
                                                label={p.label}
                                                onChange={e => ChangePropList(e, index)}
                                            >
                                                {taskItemChoices.map((Choice, i) => {
                                                    if (Choice.TaskVariableID == p.TaskVariableID) {

                                                        return (
                                                            <MenuItem key={i} value={Choice.value}>{Choice.label}</MenuItem>
                                                        );

                                                    }
                                                })}
                                            </Select>
                                        </FormControl>
                                    </div>
                                );
                            } else {
                                return (
                                    <div key={index}>
                                        <FormControl style={{ minWidth: 240 }}>
                                            <TextField
                                                id={index}
                                                label={p.label}
                                                multiline
                                                rows={6}
                                                value={p.TaskItemID}
                                                onChange={e => ChangePropList(e, index)}
                                            />
                                        </FormControl>
                                    </div>
                                    );
                            }
                        })}
                    </div>
                </DialogContent>
                }
                <Dialog
                    open={LockedAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="L&P Lock"
                    aria-describedby="Time Period locked for this work"
                >
                    <DialogTitle id="Time Entry">
                        {"Alert"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {AlertText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                    </DialogActions>
                </Dialog>
            </Dialog>  
        </div>
    );
}